module.exports = "//static.hsappstatic.net/marketplace-assets-base/static-1.5178/img/provider-signup/community-creators-image.png"